import React from "react";
import { observer, inject } from "mobx-react";
import { Collapse, Glyphicon } from "react-bootstrap";
import { DataModelWithCubes } from "../../components/detail/DataModelWithCubes";
import { StoreContext } from "../../contexts/StoreContext";
import "./CubeTypeGroup.scss";

@inject("detailViewStore", "previewStore")
@observer
export class CubeTypeGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cubeTypePanelStates: {},
    };
  }

  handleCubeTypePanelCollapse = (type, frameworkCount, cubeCount) => {
    this.setState((prevState) => ({
      cubeTypePanelStates: {
        ...prevState.cubeTypePanelStates,
        [type]:
          prevState.cubeTypePanelStates[type] === undefined
            ? cubeCount === 1 && frameworkCount === 1
            : !prevState.cubeTypePanelStates[type],
      },
    }));
  };

  getCubeTypeLabel = (type) => {
    if (!type) {
      return "Empty cube type";
    }
    switch (type.toLowerCase()) {
      case "c":
        return "Collection";
      case "d":
        return "Dissemination";
      case "eil":
        return "Enriched Input Layer";
      case "fl":
        return "Feedback Loop";
      case "il":
        return "Input Layer";
      case "nrc":
        return "Non-Reference Cube";
      case "rc":
        return "Reference Cube";
      case "s":
        return "Staging";
      case "d_as":
        return "Dissemination Analytical System";
      case "d_disc":
        return "Dissemination DISC";
      case "null":
        return "Empty cube type";
      default:
        return type;
    }
  };

  createCubeGroupsByHierarchyType = (cubesByType, objectType) => {
    const {
      searchExpr,
      frameworks,
      cubeConnections,
      cubesWithHierarchy,
      parentCubesWithHierarchy,
      childrenCubesWithHierarchy,
      getCubeHierarchiesFilteredLength,
    } = this.props;

    return Object.keys(cubesByType).map((type) => {
      const cubes = cubesByType[type];
      const countOfCubeTypes = Object.keys(cubesByType).length;
      const filteredCubes = this.context.applyFilters(cubes, searchExpr);
      const directCubes = filteredCubes.filter((cube) =>
        cubeConnections.direct.includes(cube.tid)
      );
      const childrenCubes = filteredCubes.filter((cube) =>
        cubeConnections.children.includes(cube.tid)
      );
      const parentCubes = filteredCubes.filter((cube) =>
        cubeConnections.parents.includes(cube.tid)
      );
      const cubesWithHierarchies = cubesWithHierarchy.filter(
        (cubeWithHierarchy) => cubeWithHierarchy.type === type
      );
      const childrenCubesWithHierarchies = childrenCubesWithHierarchy.filter(
        (cubeWithHierarchy) => cubeWithHierarchy.type === type
      );
      const parentCubesWithHierarchies = parentCubesWithHierarchy.filter(
        (cubeWithHierarchy) => cubeWithHierarchy.type === type
      );
      const cubesWithHierarchiesLength =
        getCubeHierarchiesFilteredLength(cubesWithHierarchies);
      const childrenCubesWithHierarchiesLength =
        getCubeHierarchiesFilteredLength(childrenCubesWithHierarchies);
      const parentCubesWithHierarchiesLength = getCubeHierarchiesFilteredLength(
        parentCubesWithHierarchies
      );

      const cubesWithHierarchyFiltered =
        this.context.applyFiltersWithCubeHierarchy(
          cubesWithHierarchies,
          searchExpr
        );
      const childrenCubesWithHierarchyFiltered =
        this.context.applyFiltersWithCubeHierarchy(
          childrenCubesWithHierarchies,
          searchExpr
        );
      const parentCubesWithHierarchyFiltered =
        this.context.applyFiltersWithCubeHierarchy(
          parentCubesWithHierarchies,
          searchExpr
        );
      const cubesWithHierarchiesFilteredLength =
        getCubeHierarchiesFilteredLength(cubesWithHierarchyFiltered);
      const childrenCubesWithHierarchiesFilteredLength =
        getCubeHierarchiesFilteredLength(childrenCubesWithHierarchyFiltered);
      const parentCubesWithHierarchiesFilteredLength =
        getCubeHierarchiesFilteredLength(parentCubesWithHierarchyFiltered);

      const filteredLength =
        filteredCubes.length +
        cubesWithHierarchiesFilteredLength +
        childrenCubesWithHierarchiesFilteredLength +
        parentCubesWithHierarchiesFilteredLength;
      const totalLength =
        cubes.length +
        cubesWithHierarchiesLength +
        childrenCubesWithHierarchiesLength +
        parentCubesWithHierarchiesLength;
      const includesCubesWithHierarchies =
        (cubesWithHierarchyFiltered && cubesWithHierarchyFiltered.length > 0) ||
        (childrenCubesWithHierarchyFiltered &&
          childrenCubesWithHierarchyFiltered.length > 0) ||
        (parentCubesWithHierarchyFiltered &&
          parentCubesWithHierarchyFiltered.length > 0)
          ? true
          : false;

      const containerLabelForCubesIncludingSpecific =
        objectType === "Variable"
          ? "Cubes including a more specific Variable"
          : "Cubes including more specific concept";
      const containerLabelForCubesIncludingGeneric =
        objectType === "Variable"
          ? "Cubes including a more generic Variable"
          : "Cubes including more generic concept";

      return (
        <div className="custom-panel" key={type}>
          <div className="custom-panel-heading">
            <h5
              onClick={() =>
                this.handleCubeTypePanelCollapse(
                  type,
                  frameworks.length,
                  countOfCubeTypes
                )
              }
            >
              <Glyphicon
                glyph={
                  this.state.cubeTypePanelStates[type] === undefined
                    ? frameworks.length === 1 && countOfCubeTypes === 1
                      ? "chevron-down"
                      : this.state.cubeTypePanelStates[type]
                      ? "chevron-down"
                      : "chevron-right"
                    : this.state.cubeTypePanelStates[type] === true
                    ? "chevron-right"
                    : "chevron-down"
                }
              />{" "}
              {this.getCubeTypeLabel(type)} ({filteredLength}/{totalLength})
            </h5>
          </div>

          <Collapse
            in={
              this.state.cubeTypePanelStates[type] === undefined
                ? frameworks.length === 1 && countOfCubeTypes === 1
                : !this.state.cubeTypePanelStates[type]
            }
          >
            <div className="custom-panel-body item-list-container">
              {filteredLength > 0 ? (
                <React.Fragment>
                  <div>
                    {cubesWithHierarchyFiltered &&
                      cubesWithHierarchyFiltered.length > 0 &&
                      cubesWithHierarchyFiltered[0].items.map((item) => {
                        return this.renderItems(
                          item.sddCubeHierarchy,
                          item.sddCubes,
                          includesCubesWithHierarchies
                        );
                      })}
                  </div>

                  {this.renderItems(
                    "",
                    directCubes,
                    includesCubesWithHierarchies,
                    "",
                    null
                  )}
                  {this.renderItems(
                    "",
                    childrenCubes,
                    includesCubesWithHierarchies,
                    containerLabelForCubesIncludingSpecific,
                    childrenCubesWithHierarchyFiltered
                  )}
                  {this.renderItems(
                    "",
                    parentCubes,
                    includesCubesWithHierarchies,
                    containerLabelForCubesIncludingGeneric,
                    parentCubesWithHierarchyFiltered
                  )}
                </React.Fragment>
              ) : (
                "Nothing found"
              )}
            </div>
          </Collapse>
        </div>
      );
    });
  };

  renderItems = (
    dataModelInfo,
    dataModelCubes,
    includesCubesWithHierarchies,
    title,
    childrenCubesWithHierarchyFiltered
  ) => {
    return dataModelCubes.length > 0 ||
      (childrenCubesWithHierarchyFiltered &&
        childrenCubesWithHierarchyFiltered.length > 0) ? (
      <div className="col-xs-12" key={dataModelInfo.tid || undefined}>
        {title && (
          <h5 className="specific-concept-cubes">
            {title}
            <hr />
          </h5>
        )}
        {childrenCubesWithHierarchyFiltered &&
          childrenCubesWithHierarchyFiltered.length > 0 && (
            <div>
              {childrenCubesWithHierarchyFiltered &&
                childrenCubesWithHierarchyFiltered.length > 0 &&
                childrenCubesWithHierarchyFiltered[0].items.map((item) => {
                  return this.renderItems(
                    item.sddCubeHierarchy,
                    item.sddCubes,
                    includesCubesWithHierarchies
                  );
                })}
            </div>
          )}
        {dataModelCubes && dataModelCubes.length > 0 && (
          <DataModelWithCubes
            dataModelInfo={dataModelInfo}
            dataModelCubes={dataModelCubes}
            initialExpanded={true}
            includesCubesWithHierarchies={includesCubesWithHierarchies}
            openLinksInNewTabs={false}
            store={this.props.previewStore}
            isDetailViewStore={this.context === this.props.detailViewStore}
            type={this.context.type}
          />
        )}
      </div>
    ) : null;
  };

  createCubeGroups = (cubesByType) => {
    const { searchExpr, frameworks, cubesWithHierarchy } = this.props;
    return Object.keys(cubesByType).map((type) => {
      const cubes = cubesByType[type];
      const filteredCubes = this.context.applyFilters(
        cubesByType[type],
        searchExpr
      );
      const countOfCubeTypes = Object.keys(cubesByType).length;
      const cubesWithHierarchies =
        cubesWithHierarchy &&
        cubesWithHierarchy.filter(
          (cubeWithHierarchy) => cubeWithHierarchy.type === type
        );
      const cubesWithHierarchiesLength =
        (cubesWithHierarchies &&
          cubesWithHierarchies.length > 0 &&
          cubesWithHierarchies[0].items.reduce((x, y) => {
            return x + y.sddCubes.length;
          }, 0)) ||
        0;

      const cubesWithHierarchyFiltered =
        this.context.applyFiltersWithCubeHierarchy(
          cubesWithHierarchies,
          searchExpr
        );
      const cubesWithHierarchiesFilteredLength =
        (cubesWithHierarchyFiltered &&
          cubesWithHierarchyFiltered.length > 0 &&
          cubesWithHierarchyFiltered[0].items.reduce((x, y) => {
            return x + y.sddCubes.length;
          }, 0)) ||
        0;

      const filteredLength =
        filteredCubes.length + cubesWithHierarchiesFilteredLength;
      const totalLength = cubes.length + cubesWithHierarchiesLength;

      const includesCubesWithHierarchies =
        cubesWithHierarchyFiltered && cubesWithHierarchyFiltered.length > 0
          ? true
          : false;

      return (
        <div className="custom-panel" key={type}>
          <div className="custom-panel-heading">
            <h5
              onClick={() =>
                this.handleCubeTypePanelCollapse(
                  type,
                  frameworks.length,
                  countOfCubeTypes
                )
              }
            >
              <Glyphicon
                glyph={
                  this.state.cubeTypePanelStates[type] === undefined
                    ? frameworks.length === 1 && countOfCubeTypes === 1
                      ? "chevron-down"
                      : this.state.cubeTypePanelStates[type]
                      ? "chevron-down"
                      : "chevron-right"
                    : this.state.cubeTypePanelStates[type] === true
                    ? "chevron-right"
                    : "chevron-down"
                  // this.state.cubeTypePanelStates[type] ||
                  // this.state.cubeTypePanelStates[type] === undefined
                  //   ? "chevron-right"
                  //   : "chevron-down"
                }
              />{" "}
              {this.getCubeTypeLabel(type)} ({filteredLength}/{totalLength})
            </h5>
          </div>
          <Collapse
            in={
              this.state.cubeTypePanelStates[type] === undefined
                ? frameworks.length === 1 && countOfCubeTypes === 1
                : !this.state.cubeTypePanelStates[type]
            }
          >
            <div className="custom-panel-body item-list-container">
              {filteredLength > 0 ? (
                <React.Fragment>
                  {cubesWithHierarchyFiltered &&
                    cubesWithHierarchyFiltered.length > 0 &&
                    cubesWithHierarchyFiltered[0].items.map((item) => {
                      return this.renderItems(
                        item.sddCubeHierarchy,
                        item.sddCubes,
                        includesCubesWithHierarchies
                      );
                    })}
                  {this.renderItems(
                    "",
                    filteredCubes,
                    includesCubesWithHierarchies,
                    ""
                  )}
                </React.Fragment>
              ) : (
                "Nothing found"
              )}
            </div>
          </Collapse>
        </div>
      );
    });
  };
  static contextType = StoreContext;
  render() {
    const {
      cubes,
      cubesWithHierarchy = [],
      parentCubesWithHierarchy = [],
      childrenCubesWithHierarchy = [],
    } = this.props;
    const { getEntityData } = this.context;
    const objectType = getEntityData.item.object.type;
    const cubesWithHierarchyCombined = cubesWithHierarchy.concat(
      parentCubesWithHierarchy,
      childrenCubesWithHierarchy
    );
    // Creating cubesByType
    const cubesByType = {};
    const cubeHierarchyTypes = cubesWithHierarchyCombined
      .map((cubeHierarchy) => cubeHierarchy.type)
      .sort();
    cubeHierarchyTypes.forEach((type) => {
      cubesByType[type] = [];
    });
    cubes.forEach((cube) => {
      const cubeType = cube.cubeType;
      if (!cubesByType.hasOwnProperty(cubeType)) {
        cubesByType[cubeType] = [];
      }
      cubesByType[cubeType].push(cube);
    });
    return objectType === "Member" || objectType === "Variable"
      ? this.createCubeGroupsByHierarchyType(cubesByType, objectType)
      : cubes
      ? this.createCubeGroups(cubesByType)
      : null;
  }
}
